/*
 *  BASE/APP
 */

import $ from 'jquery'
import slick from 'slick-carousel'
import IScroll from 'iscroll'
import drawer from 'jquery-drawer'

window.jQuery = $
window.$ = $

window.slick = slick
window.IScroll = IScroll
window.drawer = drawer

// Components
import "../../project/scripts/tracking-click"
import "../../project/scripts/slick"
import "../../project/scripts/accordion"
import "../../project/scripts/swatch-hover"
import "../../project/scripts/drawer"
import "../../project/scripts/header"
import "../../project/scripts/sticky"
import "../../project/scripts/addClickEvent"
